import React, { useState } from "react";
import { Col, Container, Dropdown, Row } from "react-bootstrap";
// import { CKEditor } from '@ckeditor/ckeditor5-react/dist/ckeditor';
// import DecoupledEditor from '@ckeditor/ckeditor5-build-decoupled-document';
import './print.scss';
import { injectIntl } from "react-intl";
import * as ReactDOMServer from 'react-dom/server';
import { PDFExport } from "@progress/kendo-react-pdf";
import QRCode from "react-qr-code";
import { Canvg } from 'canvg';
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { useEffect } from "react";
import { getBankGuarenteeLetter, createBankGuarenteeLetter } from '../../services/api';
import { ToastContainer, toast } from 'react-toastify';
import blImageHeader from '../../assets/images/Header.jpg';
import ExportHTMLToWord from "./html-todocx";
const PrepareLetter = (props) => {
    const { serialNo, refNo, back } = props;
    let [searchParams, setSearchParams] = useSearchParams();

    const letterData = {
        serialNumber: 'BL' + serialNo,
        content: ''
    }
    const [time, setTime] = useState(null);
    const [saved, setSaved] = useState(false);

    const navigate = useNavigate();
    const [data, setData] = useState('');
    useEffect(() => {
        let ckeditor = document.createElement("script");
        ckeditor.src = "ckeditor4/custom.js";
        ckeditor.defer = true;
        document.head.appendChild(ckeditor);
        let ckeditorRender = document.createElement("script");
        getBankGuarenteeLetter(letterData).then(res => {
            if (res && res.data && res.data.content && res.data.content.content) {
                window.tmp = res.data.content.content;
                ckeditorRender = document.createElement("script");
                ckeditorRender.innerHTML = "CKEDITOR.instances['editor'].setData(window.tmp)";
                document.body.appendChild(ckeditorRender);
            }
        });

    }, []);
    const [editor, setEditor] = useState('');
    const toolbar = ['fontfamily', 'fontsize', '|', "bold", "italic", "underline", '|', 'alignment:left', 'alignment:center', 'alignment:right', 'alignment:justify', '|',
        "indent", "outdent", '|', "numberedList", "bulletedList", '|', 'undo', 'redo'];
    const fontSizeOption = [
        {
            title: '10pt',
            model: '10pt'
        },
        {
            title: '11pt',
            model: '11pt'
        },
        {
            title: '12pt',
            model: '12pt'
        },
        {
            title: '13pt',
            model: '13pt'
        },
        {
            title: '14pt',
            model: '14pt'
        },
        {
            title: '15pt',
            model: '15pt'
        },

    ];
    const fontFamilyOption = [
        'Times New Roman, Times, serif',
        'Tahoma, Geneva, sans-serif',
        'Arial, Helvetica, sans-serif',
        'Calibri, sans-serif'
    ]

    window.inputHandler = (prepareData) => {
        setData(prepareData)
        setTime(resetTimeout(time, setTimeout(saveValue(prepareData), 1200)))
    }
    const resetTimeout = (id, newID) => {
        clearTimeout(id)
        return newID
    }
    const saveValue = (prepareData) => {
        setSaved(true);
        setTimeout(() => { setSaved(false); onSave(prepareData); }, 1500)
    };
    const onSave = (prepareData) => {
        if (prepareData != '') {
            const letterForm = {
                serialNumber: 'BL' + serialNo,
                content: prepareData
            }
            createBankGuarenteeLetter(letterForm).then(res => {
               console.log('saved');
            })
        }
    }
    const print = () => {
        let ckeditor = document.createElement("script");
        ckeditor.innerHTML = "var letterContent = CKEDITOR.instances['editor'].getData();" +
            "$('#print-letter .content').html(letterContent);" +
            "window.print();";
        document.body.appendChild(ckeditor);
    }

    const exportPdf = () => {
        let ckeditor = document.createElement("script");
        ckeditor.innerHTML = "var letterContent = CKEDITOR.instances['editor'].getData();" +
            "$('.pdf-content').html(letterContent);";
        document.body.appendChild(ckeditor);
    }

    const qrCodeUrl = process.env.REACT_APP_KHDN_BASE_URL + 'tracuubaolanh?serialNo=BL' + serialNo;
    const pdfExportComponent = React.useRef(null);
    const qrCode = ReactDOMServer.renderToString(<QRCode value={qrCodeUrl} level="M" size={70} />);
    const svgToPng = async () => {
        let v = null;
        const canvas = document.querySelector('canvas');
        const ctx = canvas.getContext('2d');
        v = await Canvg.fromString(ctx, qrCode);
        v.start();
        const imgUrl = canvas.toDataURL("img/png");
        v.stop(); return imgUrl;
    };
    const exportToWord = async () => {
        // let rulerStyle = document.getElementById("ruler-style");
        // rulerStyle = JSON.parse(rulerStyle.value);
        let stringContent = window.wordData();
        // let bodyStyle = "margin-top:1cm;font-size:10pt;margin-left:" + rulerStyle.left + "cm;" + "margin-right:" + (21 - rulerStyle.right) + "cm";
        var header = "<html xmlns:o='urn:schemas-microsoft-com:office:office' " +
            "xmlns:w='urn:schemas-microsoft-com:office:word' " +
            "xmlns='http://www.w3.org/TR/REC-html40'>" +
            "<head><meta charset='utf-8'><title>" + refNo + "</title></head><body>";
        var footer = "</body></html>";
        var qrSourc = '';
        if (!qrCode.match(/^<svg[^>]+xmlns="http\:\/\/www\.w3\.org\/2000\/svg"/)) {
            qrSourc = qrCode.replace(/^<svg/, '<svg xmlns="http://www.w3.org/2000/svg"');
        }
        if (!qrCode.match(/^<svg[^>]+"http\:\/\/www\.w3\.org\/1999\/xlink"/)) {
            qrSourc = qrCode.replace(/^<svg/, '<svg xmlns:xlink="http://www.w3.org/1999/xlink"');
        }
        qrSourc = '<?xml version="1.0" standalone="no"?>\r\n' + qrCode;
        var imageUrl = await svgToPng();
        var sourceHTML = header +
            '<div style="text-align:right;margin-right:1cm"><strong style="font-family: \'Times New Roman, Times, serif\'" !important;>Số tham chiếu: ' + refNo + '</strong></div><div style="margin-bottom:3cm">' + stringContent + '</div>' +
            '<table>' +
            '<tr>' +
            '<td style="width:15%">' + '<img src="' + imageUrl + '"><br/><b style="font-size:11pt;">BL' + serialNo + '</b>' + '</td>' +
            ' <td>' +
            '<p>' +
            '<b>' +
            'Để kiểm tra tính xác thực của Thư bảo lãnh, bên nhận bảo lãnh thực hiện:' +
            ' </b>' +
            '  </p>' +
            '<span style="font-family: \'Times New Roman, Times, serif\'" !important;>Truy cập <a href="https://ibanking.shb.com.vn/dn/tracuubaolanh" style="text-decoration:none;">https://ibanking.shb.com.vn/dn/tracuubaolanh</a>' +
            '&nbsp; hoặc sử dụng Smartphone quét mã QR trên thư bảo lãnh này hoặc liên hệ tổng đài: <a href="tel:*6688" style="text-decoration:none;">*6688</a> / E-mail: <a href="mailto:baolanh@shb.com.vn" style="text-decoration:none;">baolanh@shb.com.vn</a></span>' +
            '</td>' +
            '</tr>' +
            '</table>' + footer;
        ExportHTMLToWord(sourceHTML, refNo);
    }

    return (
        <React.Fragment>
            <ToastContainer autoClose={1000} />

            <div className="py-5" id="prepare-letter">
                <div id="canvas" className="d-none">
                    <canvas id="myCanvas" width="1100" height="150" ></canvas>
                </div>
                <div className="form-write-letter-container d-flex justify-content-center">
                    <div className="form-write-letter position-relative">
                        <strong className="serialNo">BL{serialNo}</strong>
                        <strong className="ref">Số tham chiếu: <span className="ref-no">{refNo}</span></strong>
                        <div className="editor-container">
                            <div id="editor">{data}</div>
                        </div>
                        <div className="qr-container position-absolute">
                            <Row>
                                <Col lg={2} md={4}>
                                    <div className="d-grid justify-content-center text-center" style={{ background: 'transparent' }}>
                                        <QRCode value={qrCodeUrl} level="M" size={70} />
                                        <strong className="refNo">BL{serialNo}</strong>
                                    </div>
                                </Col>
                                <Col lg={10} md={8} >
                                    <div className="qr-message">
                                        <p>
                                            <b>
                                                Để kiểm tra tính xác thực của Thư bảo lãnh, bên nhận bảo lãnh thực hiện:
                                            </b>
                                        </p>
                                        <span>Truy cập <a href="https://ibanking.shb.com.vn/dn/tracuubaolanh" className="text-decoration-none">https://ibanking.shb.com.vn/dn/tracuubaolanh</a>
                                            &nbsp; hoặc sử dụng Smartphone quét mã QR trên thư bảo lãnh này hoặc liên hệ tổng đài: <a href="tel:*6688" className="text-decoration-none">*6688</a> / E-mail: <a href="mailto:baolanh@shb.com.vn" className="text-decoration-none">baolanh@shb.com.vn</a></span>
                                    </div>
                                </Col>
                            </Row>
                        </div>
                    </div>
                </div>
                <div className="d-flex justify-content-center mt-2 position-relative">
                    <button className="btn btn-shb-back mt-2 mx-3" onClick={() => { back(); }}>QUAY LẠI</button>
                    <Dropdown >
                        <Dropdown.Toggle variant="success" id="dropdown-basic" className="btn-shb mt-2 mx-3 mb-5">
                            TẢI VỀ
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                            <Dropdown.Item onClick={() => {
                                exportPdf();
                                if (pdfExportComponent.current) {
                                    pdfExportComponent.current.save();
                                }
                            }}>TẢI VỀ PDF </Dropdown.Item>
                            <Dropdown.Item onClick={() => { exportToWord() }} > TẢI VỀ WORD </Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>
                    <button className="btn btn-shb-outline mt-2 mx-3" onClick={() => { print() }}>IN</button>
                </div>
            </div>
            <div className="pdf-frame">
                <PDFExport
                    scale={0.8}
                    paperSize="A4"
                    ref={pdfExportComponent}
                    fileName={refNo}
                    title={refNo}
                >
                    <div className="pdf-cover">
                        <img className="bl-header" src={blImageHeader} />
                        <div className="bl-code"><strong >BL{serialNo}</strong></div>
                        <div className="pdf-ref"><strong >Số tham chiếu: {refNo}</strong></div>
                        <div className="pdf-content"></div>
                        <div className="qr-container">
                            <div className="qr-code" style={{ background: 'transparent' }}>
                                <QRCode value={qrCodeUrl} level="M" size={70} />
                                <strong className="refNo">BL{serialNo}</strong>
                            </div>
                            <div className="qr-message">
                                <p>
                                    <b>
                                        Để kiểm tra tính xác thực của Thư bảo lãnh, bên nhận bảo lãnh thực hiện:
                                    </b>
                                </p>
                                <span>Truy cập <a href="https://ibanking.shb.com.vn/dn/tracuubaolanh" className="text-decoration-none">https://ibanking.shb.com.vn/dn/tracuubaolanh</a>
                                    &nbsp; hoặc sử dụng Smartphone quét mã QR trên thư bảo lãnh này hoặc liên hệ tổng đài: <a href="tel:*6688" className="text-decoration-none">*6688</a> / E-mail: <a href="mailto:baolanh@shb.com.vn" className="text-decoration-none">baolanh@shb.com.vn</a></span>
                            </div>
                        </div>
                    </div>
                </PDFExport>
            </div>
            <div id="print-letter">
                <div className="ref"><strong >Số tham chiếu: {refNo}</strong></div>
                <div className="content"></div>
                <div className="qr-container">
                    <div className="qr-code" style={{ background: 'transparent' }}>
                        <QRCode value={qrCodeUrl} level="M" size={70} />
                        <strong className="refNo">BL{serialNo}</strong>
                    </div>
                    <div className="qr-message">
                        <p>
                            <b>
                                Để kiểm tra tính xác thực của Thư bảo lãnh, bên nhận bảo lãnh thực hiện:
                            </b>
                        </p>
                        <span>Truy cập <a href="https://ibanking.shb.com.vn/dn/tracuubaolanh" className="text-decoration-none">https://ibanking.shb.com.vn/dn/tracuubaolanh</a>
                            &nbsp;hoặc sử dụng Smartphone quét mã QR trên thư bảo lãnh này hoặc liên hệ tổng đài: <a href="tel:*6688" className="text-decoration-none">*6688</a> / E-mail: <a href="mailto:baolanh@shb.com.vn" className="text-decoration-none">baolanh@shb.com.vn</a></span>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
}

export default injectIntl(PrepareLetter);